require('../../modules/es6.function.has-instance');
module.exports = require('../../modules/_wks-ext').f('hasInstance');


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/symbol/has-instance.js
// module id = 170
// module chunks = 0